import { ChainId } from "@looksrare/config";
import { getSupportedNetworkFromChainId } from "@looksrare/utils";
import { MoDAssetPair } from "@looksrare/yolo-games-gql-typegen";
import { getUrlPairFromAssetPair } from "./transformUrlPair";

export const getMoDUrl = (chainId: ChainId, assetPair: MoDAssetPair, urlPrefix = "/moon-or-doom"): string => {
  return `${urlPrefix}/${getSupportedNetworkFromChainId(chainId)}/${getUrlPairFromAssetPair(assetPair)}`;
};
